import React, { useState } from 'react';
import {
	Wrapper,
	LinkContainer,
	Link,
	Image,
	StyledMenuIcon,
	StyledButton,
	MenuImage,
	StyledCloseIcon,
	MenuWrapper,
} from './styled';
import Logo from 'assets/logo.svg';
import LogoGreen from 'assets/logo-green.svg';
import routes from 'routes/routes';
import { APP_URL } from 'services/session';
import { withRouter } from 'react-router-dom';

const TopBar = (props) => {
	const [open, setOpen] = useState(false);
	const path = props.location.pathname;
	return (
		<Wrapper>
			<Image
				src={Logo}
				alt='Logo'
				onClick={() => props.history.push(routes.HOME)}
			/>
			<StyledMenuIcon onClick={() => setOpen(true)} />
			<LinkContainer open={open}>
				<MenuWrapper open={open}>
					<MenuImage
						src={LogoGreen}
						open={open}
						alt='Logo'
						onClick={() => {
							setOpen(false);
							props.history.push(routes.HOME);
						}}
					/>
					<StyledCloseIcon
						open={open}
						onClick={() => setOpen(false)}
					/>
				</MenuWrapper>
				<Link
					active={path === routes.WHY_FLASS}
					onClick={() => {
						setOpen(false);
						props.history.push(routes.WHY_FLASS);
					}}>
					Why Flass?
				</Link>
				<Link
					active={path === routes.PRICING}
					onClick={() => {
						setOpen(false);
						props.history.push(routes.PRICING);
					}}>
					Pricing
				</Link>
				<Link
					active={path === routes.CAREERS}
					onClick={() => {
						setOpen(false);
						props.history.push(routes.CAREERS);
					}}>
					Careers
				</Link>
				<StyledButton
					onClick={() =>
						(window.location.href = APP_URL)
					}
					open={open}>
					Log In
				</StyledButton>
			</LinkContainer>
		</Wrapper>
	);
};

export default withRouter(TopBar);
